import * as TY from 'containers/pages/users/constants';

/**
 * @function mergePhone
 * @async
 * @param { Array } users
 * @returns { Promise<Array> } _users
 */
function mergePhone(users) {
	const _users = users.map((user) => {
		let isEnabled = null;
		let phone = null;

		user.isEnabled === 'Y' ? (isEnabled = 'Yes') : (isEnabled = 'No');
		user.phoneDial === ''
			? (phone = user.phone + ' ' + user.phoneExt)
			: (phone = user.phoneDial + ' ' + user.phone + ' ' + user.phoneExt);

		return {
			[TY.ID]: user.id,
			[TY.CONTACT_ID]: user.contactId,
			[TY.F_NAME]: user.firstName,
			[TY.L_NAME]: user.lastName,
			[TY.PHONE_WORK]: phone,
			[TY.EMAIL_WORK]: user.email,
			[TY.U_NAME]: user.username,
			[TY.MST_CUST_ID]: user.masterCustId,
			[TY.IS_ENABLED]: isEnabled,
		};
	});

	return _users;
}

export default mergePhone;
